import * as v from "valibot";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import {
  CorasFooter,
  CorasDetailsPage,
  CorasNavBar,
} from "@coras-io/web-components-react";
import {
  SupportedCurrencies,
  SupportedLocales,
} from "@coras-io/web-components/types";
import { config, site } from "../config.ts";
import { handleParamsUpdate } from "../utils.ts";

const routeParamsSchema = v.object({
  locale: v.optional(v.picklist(config.locales), config.locale),
  currency: v.optional(v.picklist(config.currencies), config.currency),
  id: v.string(),
});

const searchParamsSchema = v.object({
  date: v.optional(v.string()),
});

export const Route = createFileRoute("/$locale/$currency/$id")({
  component: DetailsPageComponent,
  beforeLoad: ({ params }) => {
    if (!v.safeParse(routeParamsSchema, params).success) {
      throw redirect({
        replace: true,
        to: "/$locale/$currency",
        params: {
          locale: config.locale,
          currency: config.currency,
        },
      });
    }
  },
  params: { parse: (rawParams) => v.parse(routeParamsSchema, rawParams) },
  validateSearch: searchParamsSchema,
  head: () => {
    return {
      meta: [
        {
          title: site.title,
        },
        {
          name: "description",
          content: site.description,
        },
      ],
    };
  },
});

function DetailsPageComponent() {
  const { locale, currency, id } = Route.useParams();
  const { date } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  // @ts-ignore
  const onParamsUpdate = (params) => {
    return handleParamsUpdate(navigate, params);
  };

  const goToHomePage = async () => {
    await navigate({
      resetScroll: true,
      to: `/${locale}/${currency}`,
    });
  };

  return (
    <CorasDetailsPage
      apiHost={import.meta.env.VITE_API_HOST}
      distributorID={import.meta.env.VITE_DISTRIBUTOR_ID}
      locales={config.locales}
      locale={locale as SupportedLocales}
      currencies={config.currencies}
      currency={currency as SupportedCurrencies}
      assetsURL={import.meta.env.VITE_ASSETS_URL}
      attractionId={id}
      date={date}
      onParamsUpdate={onParamsUpdate}
    >
      <CorasNavBar slot="navbar">
        <img
          className="logo"
          src={site.logo}
          alt={site.title}
          slot="logo"
          onClick={goToHomePage}
        />
      </CorasNavBar>
      <CorasFooter slot="footer" />
    </CorasDetailsPage>
  );
}
